import { m } from '@sohanscript/i18n';
import { useMousePosition } from '@sohanscript/lib/hooks/mouse-position';
import { useCallback, useRef } from 'react';

export function CursorTracker({ children }: { children: React.ReactNode }) {
	const divRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);

	const update = useCallback(({ x, y }: { x: number; y: number }) => {
		const offsetX = (infoRef.current?.offsetWidth || 0) / 2;
		const offsetY = (infoRef.current?.offsetHeight || 0) / 2;
		infoRef.current?.style.setProperty('--x', `${x - offsetX}px`);
		infoRef.current?.style.setProperty('--y', `${y - offsetY}px`);
	}, []);

	useMousePosition(divRef, update);

	return (
		<div ref={divRef} className="group relative">
			{children}
			<div
				ref={infoRef}
				style={{ transform: 'translate(var(--x), var(--y))' }}
				className="pointer-events-none absolute top-0 left-0 z-50 rounded-full bg-background/40 px-4 py-2 font-bold text-sm text-white opacity-0 backdrop-blur-xl duration-0 group-hover:opacity-100"
			>
				{m.cursor_explore_work()}{' '}
				<span aria-hidden className="inline-block rtl:-scale-x-100">
					&rarr;
				</span>
			</div>
		</div>
	);
}
